<template>

  <vx-card :title="$t('class-room.course-outline-desc')" class="mb-4">

    <div class="text-center mb-2 text-nline">
      <div v-if="classRoom">
        <h4>{{ classRoom.subject.code }}</h4>
      </div>
      <h4 v-else>-</h4>

      <p class="text-grey" v-if="classRoom">{{ classRoom.subject.nameLocal }}</p>
      <p v-else>-</p>
    </div>

    <ul>
      <li
        class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
              <span class="flex items-center">
                <feather-icon icon="BookOpenIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                <span class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-units-qty') }}</span>
              </span>
        <span :class="courseOutlineUnitQty === 0 ? 'text-danger':''">
                {{ courseOutlineUnitQty }}
              </span>
      </li>

      <li
        class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                <span class="flex items-center">
                  <feather-icon icon="VideoIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                  <span
                    class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-qty') }}</span>
                </span>
        <span :class="totalVdoQty === 0 ? 'text-danger':''">
                  {{ totalVdoQty }}
                </span>
      </li>

      <li
        class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                <span class="flex items-center">
                  <feather-icon icon="FilmIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                  <span class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-total-length') }}</span>
                </span>
        <span :class="totalVdoLength === '00:00:00' ? 'text-danger':''">
                  {{ totalVdoLength }}
                </span>
      </li>

    </ul>

  </vx-card>

</template>

<script>
  import {state, getClassSectionById} from '../data';
  import {secondToHHMMSSFormat} from "@/utils/data";
  import {hasVideo} from "@/utils/video-source";

  import ClassSection from '@/store/modules/courses/class-section/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  if (!state.store.ClassSection) state.registerModule(`ClassSection`, ClassSection);

  const {
    mapActions: mapClassSectionActions,
  } = createNamespacedHelpers(`ClassSection`);

  const {
    mapFields: mapClassSectionFields,
  } = createHelpers({
    getterType: `ClassSection/getField`,
    mutationType: `ClassSection/updateField`,
  });


  export default {
    components: {},
    data() {
      return {
        local: state.local,
        store: state.store,
        form: state.local.form,

        classRoomEdit: state.local.classRoomEdit,
        subjectInfo: state.local.subjectInfo,

      }
    },
    computed: {
      ...mapClassSectionFields({classSectionProcessing: 'processing'}),
      classSection() {
        return this.subjectInfo.classSection;
      },
      classRoom() {
        return this.classRoomEdit.selectedClassRoom;
      },
      courseOutlineUnitQty() {
        let courseOutlineUnitQty = 0;
        if (this.subjectInfo.classSection && this.subjectInfo.classSection.courseOutline.courseOutlineUnits.length > 0) {
          courseOutlineUnitQty = this.classSection.courseOutline.courseOutlineUnits.length;
        }
        return courseOutlineUnitQty;
      },
      totalVdoLength() {
        let totalVdoLength = '00:00:00';
        if (this.subjectInfo.classSection) {
          totalVdoLength = secondToHHMMSSFormat(this.subjectInfo.classSection.vdoSet.totalVdoLength);
        }
        return totalVdoLength;
      },
      // hasVideo, not vdoStreamPath: Bunny topics have no vdoStreamPath and
      // were being counted as no video at all.
      totalVdoQty() {
        let totalVdoQty = 0;
        if (this.subjectInfo.classSection) {
          this.subjectInfo.classSection.vdoSet.vdoSetUnits.forEach(vdoUnit => {
            if (vdoUnit.vdoSetTopics && vdoUnit.vdoSetTopics.length > 0) {
              vdoUnit.vdoSetTopics.forEach(vdoTopic => {
                totalVdoQty += hasVideo(vdoTopic) ? 1 : 0;
              })
            }
          });
        }
        return totalVdoQty;
      },
    },
    watch: {
      classSectionProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapClassSectionActions({
        getClassSection: 'getClassSection',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//

      //---------------------------------------- Local Function ------------------------------------------------------//
      async initData() {
        let func = {
          getClassSection: this.getClassSection,
        }
        await getClassSectionById(func);
      },
    },
    async mounted() {
      await this.initData();
    }
  }
</script>

<style scoped>
</style>
